import { SETTEXT, WORKERLOOKUP, FETCH } from './actionType'
import axios from 'axios'
import tapConfig from '../../tapConfig'

export function setText(data) {
  return {
    type: SETTEXT,
    data: data,
  }
}

export function workerLookup(group_id, locationTypeList) {
  return function (dispatch) {
    tapConfig()
      .then((config) => {
        const apiKey = config.target_outreach_manager.apiKey
        dispatch(apiFetching(true))
        let urlString =
          config.target_outreach_manager.url +
          'target_emergency_alerts/v1/selection_lists?key=' +
          encodeURIComponent(apiKey) +
          '&group_id=' +
          encodeURIComponent(group_id)
        // add loop
        for (var i = 0; i < locationTypeList.length; i++) {
          urlString =
            urlString +
            '&location_type=' +
            encodeURIComponent(locationTypeList[i])
        }
        axios
          .get(urlString, { crossdomain: true })
          .then(function (response) {
            dispatch(workerLookupResponseData(response))
            dispatch(apiFetching(false))
          })
          .catch(function () {
            // removed error from function
            dispatch(apiFetching(false))
          })
      })
      .catch((error) => {
        console.error('Error fetching tapConfig:', error)
        dispatch(apiFetching(false))
      })
  }
}
function workerLookupResponseData(response) {
  return {
    type: WORKERLOOKUP,
    data: response.data,
  }
}

function apiFetching(status) {
  return {
    type: FETCH,
    fetching: status,
  }
}
